export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";